import type { GenericSchema } from "valibot";

export type NavMenuItem = {
  id: number;
  title: string;
  description: string;
  url: string;
  target: string;
  parent_id: number;
  current: boolean;
  class: string;
  children: NavMenuItem[];
};

export const navMenuItemSchema: GenericSchema<NavMenuItem> = v.object({
  id: v.number(),
  title: v.string(),
  description: v.string(),
  url: v.string(),
  target: v.string(),
  parent_id: v.number(),
  current: v.boolean(),
  class: v.string(),
  children: v.array(v.lazy(() => navMenuItemSchema)),
});
